import React, { useEffect, useState } from "react";
import { Eye } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Diskrétne počítadlo návštev v pätičke.
const VisitCounter = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/stats/visits`)
      .then((res) => setStats(res.data))
      .catch(() => {});
  }, []);

  if (!stats) return null;

  return (
    <div className="inline-flex items-center gap-2 text-campaign-ink/60 text-sm font-semibold">
      <Eye size={16} className="text-campaign-coral" />
      <span>
        {stats.unique_visitors.toLocaleString("sk-SK")} návštevníkov ·{" "}
        {stats.total_views.toLocaleString("sk-SK")} zobrazení
      </span>
    </div>
  );
};

export default VisitCounter;
